import type { SVGProps } from 'react';

export const DownloadPDF = (props: SVGProps<any>) => (
  <svg
    height="32px"
    version="1.1"
    viewBox="0 0 32 32"
    width="32px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <title>{'download-pdf'}</title>
    <g
      fill="none"
      fillRule="evenodd"
      id="icons/download-pdf-[TEMP]"
      stroke="none"
      strokeWidth="1"
    >
      <rect height="32" id="Rectangle" width="32" x="0" y="0"></rect>
      <g id="download-pdf">
        <path
          d="M25,0.75 C25.8974627,0.75 26.7099627,1.11376864 27.298097,1.70190296 C27.8862314,2.29003728 28.25,3.10253728 28.25,4 L28.25,18.25 L31.25,18.25 L31.25,27.7501869 L28.2404784,27.7509369 C28.3209423,28.8219969 27.8809204,29.7928587 27.148192,30.4388709 C26.5754928,30.9437929 25.8234895,31.25 25,31.25 L7,31.25 C6.17651049,31.25 5.42450722,30.9437929 4.85180803,30.4388709 C4.11907958,29.7928587 3.67905767,28.8219969 3.75952158,27.7509369 L0.75,27.7501869 L0.75,18.25 L3.75,18.25 L3.75,4 C3.75,3.10253728 4.11376864,2.29003728 4.70190296,1.70190296 C5.29003728,1.11376864 6.10253728,0.75 7,0.75 Z"
          id="Combined-Shape"
          stroke={props.fill}
          strokeWidth="1.5"
        ></path>
        <rect
          height="9.5"
          id="Rectangle"
          stroke={props.fill}
          strokeWidth="1.5"
          width="30.5"
          x="0.75"
          y="18.25"
        ></rect>
        <g
          fill={props.fill}
          fillRule="nonzero"
          id="PDF"
          transform="translate(10, 20.5)"
        >
          <path
            d="M0,0 L0,5 L1.10260973,5 L1.10260973,3.11428571 L1.71945433,3.11428571 C2.64472123,3.11428571 3.7396204,2.7 3.7396204,1.55 C3.7396204,0.414285714 2.63701068,0 1.71945433,0 L0,0 Z M1.10260973,0.864285714 L1.6886121,0.864285714 C2.21293001,0.864285714 2.56761566,1.12857143 2.56761566,1.57142857 C2.56761566,2.07142857 2.12811388,2.25 1.54211151,2.25 L1.10260973,2.25 L1.10260973,0.864285714 Z"
            id="P"
          ></path>
          <path
            d="M4.49525504,5 L5.99881376,5 C7.47924081,5 9.02906287,4.32857143 9.02906287,2.47857143 C9.02906287,0.671428571 7.46381969,0 6.06820878,0 L4.49525504,0 L4.49525504,5 Z M5.59786477,0.864285714 L5.9371293,0.864285714 C7.14768683,0.864285714 7.84934757,1.44285714 7.84934757,2.54285714 C7.84934757,3.72142857 6.98576512,4.13571429 5.72123369,4.13571429 L5.59786477,4.13571429 L5.59786477,0.864285714 Z"
            id="D"
          ></path>
          <polygon
            id="F"
            points="13 2.98571429 13 2.12142857 11.1109134 2.12142857 11.1109134 0.864285714 13 0.864285714 13 0 10.0083037 0 10.0083037 5 11.1109134 5 11.1109134 2.98571429"
          ></polygon>
        </g>
        <g
          id="Group-2"
          stroke={props.fill}
          strokeWidth="1.5"
          transform="translate(8, 4)"
        >
          <line
            id="Line-2"
            strokeLinecap="square"
            x1="0"
            x2="16"
            y1="11.5"
            y2="11.5"
          ></line>
          <rect
            height="4.5"
            id="Rectangle"
            width="2.75"
            x="1.25"
            y="6.75"
          ></rect>
          <rect
            height="7.5"
            id="Rectangle-Copy-8"
            width="2.75"
            x="6.5"
            y="3.75"
          ></rect>
          <rect
            height="10.5"
            id="Rectangle-Copy-9"
            width="2.75"
            x="11.75"
            y="0.75"
          ></rect>
        </g>
      </g>
    </g>
  </svg>
);
